import { t } from 'localization'

const TP = 'shared.utils.shipping-method-utils'

export const getShippingMethodText = (method: string) => {
  switch (method.toLowerCase()) {
    case 'standard':
      return t(`${TP}.standard`, 'Standard')
    case 'expedited':
      return t(`${TP}.expedited`, 'Expedited')
    case 'next_day':
      return t(`${TP}.next_day`, 'Next Day')
    default:
      return method
  }
}
